import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import HomeFilter from '../components/HomeFilter'
import ContactForm from '../components/ContactForm'
import AnnouncesEvents from '../components/announces-events'

export default function EventPage() {
  const { t } = useTranslation()
  const location = useLocation()
  const [statusFilter, setStatusFilter] = useState<string | null>(null)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const status = searchParams.get('status')
    setStatusFilter(status)
  }, [location])

  return (
    <>
      <div
        id='premium-slider'
        className='text-center w-full align-middle bg-redpink text-white py-3'
      >
        <p className='uppercase text-2xl'>{t('events-corner')}</p>
        <p className=''>{t('events-corner-desc')}</p>
      </div>

      <div
        id='announces-home'
        className='w-full mt-5 mx-auto justify-center text-anthracite'
      >
        <AnnouncesEvents initialStatusFilter={statusFilter} />
      </div>

      <ContactForm />
    </>
  )
}
